import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=a5be7e22&scoped=true&"
import script from "./BankForm.vue?vue&type=script&lang=js&"
export * from "./BankForm.vue?vue&type=script&lang=js&"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=a5be7e22&prod&lang=scss&"
import style1 from "./BankForm.vue?vue&type=style&index=1&id=a5be7e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5be7e22",
  null
  
)

export default component.exports